class MobileMenuCarousel extends HTMLElement {
  constructor () {
    super()

    this.containerEl = this.querySelector(
      '[data-el="mobile-menu-carousel.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="mobile-menu-carousel.slide"]'
    )
    this.scrollerEl = this.querySelector(
      '[data-el="mobile-menu-carousel.scroller"]'
    )
    // eslint-disable-next-line no-unused-expressions
    this.carouselInstance

    document.addEventListener('mobile-menu:open', event => {
      this.carouselInstance = this.initialiseCarousel()
    })
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.containerEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 2.25,
      spacing: 10,
      rubberband: false,
      slideChanged: instance => {},
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      }
    })
  }
}

customElements.define('mobile-menu-carousel', MobileMenuCarousel)
